// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"66d2cca4","453":"650da9c5","553":"988df5e6"}[chunkId] + ".chunk.js";
};